module.exports = __webpack_public_path__ + "static/media/guoyoumin.170c68e6.png";